import { render, staticRenderFns } from "./ModalRemunerationForm.vue?vue&type=template&id=42c8fe0b"
import script from "./ModalRemunerationForm.vue?vue&type=script&lang=js"
export * from "./ModalRemunerationForm.vue?vue&type=script&lang=js"
import style0 from "./ModalRemunerationForm.vue?vue&type=style&index=0&id=42c8fe0b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../ChatGenial-hom-sync/client/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports